module.exports = __webpack_public_path__ + "static/thumbnail-a501a7621c6fde8103bac229fc87e1f6.png";